import { configureStore } from '@reduxjs/toolkit';
import draftConfigReducer from './features/draftConfig/draftConfigSlice';
import stimulyatorDraftRoomReducer from './features/stimulyatorDraftRoom/stimulyatorDraftRoomSlice';
import draftConfigurationDataReducer from './features/draftConfigurationDataSlice/draftConfigurationDataSlice';
import podcasterReducer from './features/podcasters/podcastersSlice';
import draftEventsReducer from './features/draftEvents/draftEventsSlice';
import draftResultReducer from './features/draftResult/draftResultSlice';
import playersDraftTeamReducer from './features/draftTeam/playersDraftTeamSlice';
import playersDraftRoomReducer from './features/playersRoomDraft/playersRoomDraftSlice';
import draftValueReducer from './features/draftValue/draftValueSlice';
import groupReducer from './features/group/groupSlice';
import liveDraftReducer from './features/liveDraft/liveDraftSlice';
import liveResultReducer from './features/liveResult/liveResultSlice';
import liveTradesReducer from './features/liveTrades/liveTradesSlice';
import myPlayersReducer from './features/myPlayers/myPlayersSlice';
import nflDraftFanaticsListBotsReducer from './features/nfldraftfanaticsSlice/nfldraftfanaticsSlice';
import planReducer from './features/plan/planSlice';
import playersReducer from './features/players/playersSlice';
import playersDraftReducer from './features/playersDraft/playersDraftSlice';
import rankingReducer from './features/ranking/rankingSlice';
import simulatorToSimulatorReducer from './features/simulatorToSimulator/simulatorToSimulatorSlice';
import teamListReducer from './features/teamList/teamListSlice';
import teamListBotsReducer from './features/teamListBots/teamListBotsSlice';
import teamNeedsReducer from './features/teamNeeds/teamNeedsSlice';
import tradesReducer from './features/trades/tradesSlice';
import userReducer from './features/user/userSlice';
import draftCountReducer from './features/draftCount/draftCountSlice'
import scoutingReducer from "./features/scoutingReports/reportSlice";
import draftRoomV2PlayersReducer from './features/draftRoomV2Players/draftRoomV2PlayersSlice';
import commonSettingsReducer from './features/commonSettings/commonSettingsSlice';
import articlesReducer from './features/articles/articlesSlice';
import draftProfessorReducer from './features/draftProfessor/draftProfessorSlice';
import summerPodcastsReducer from './features/summerPodcasts/summerPodcastsSlice';


export const store = configureStore({
	reducer: {
		user: userReducer,
		players: playersReducer,
		playersDraftTeam: playersDraftTeamReducer,
		playersDraftRoom:playersDraftRoomReducer,
		draftConfigurationData: draftConfigurationDataReducer,
		group: groupReducer,
		draftConfig: draftConfigReducer,
		stimulyatorDraftRoom:stimulyatorDraftRoomReducer,
		teamNeeds: teamNeedsReducer,
		playersDraft: playersDraftReducer,
		teamList: teamListReducer,
		teamListBots: teamListBotsReducer,
		draftResult: draftResultReducer,
		draftValue: draftValueReducer,
		trades: tradesReducer,
		simulatorToSimulator: simulatorToSimulatorReducer,
		draftEvents: draftEventsReducer,
		liveDraft: liveDraftReducer,
		plan: planReducer,
		liveResult: liveResultReducer,
		liveTrades: liveTradesReducer,
		myPlayers: myPlayersReducer,
		nflDraftFanaticsListBots: nflDraftFanaticsListBotsReducer,
		ranking: rankingReducer,
		podcasters:podcasterReducer,
		draftCount:draftCountReducer,
		scoutingReports: scoutingReducer,
		draftRoomV2Players: draftRoomV2PlayersReducer,
		commonSettings: commonSettingsReducer,
		articles: articlesReducer,
		draftProfessor: draftProfessorReducer,
		summerPodcasts: summerPodcastsReducer,
	},
});
